import {Box, Flex, Text, Image, SimpleGrid} from "@mantine/core";
import {IconPlus} from "@tabler/icons-react";
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';
import {decode} from "html-entities";

const _CategoryWithProduct = ({component}) => {
  return (
      <Box
          bg={component?.customize_styles?.general_decoration?.background_color}
          mx={component?.customize_styles?.general_decoration?.margin_x}
          my={component?.customize_styles?.general_decoration?.margin_y}
          px={component?.customize_styles?.general_decoration?.padding_x}
          py={component?.customize_styles?.general_decoration?.padding_y}
          style={{
              boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
              borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
              border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
          }}
      >
          <SimpleGrid cols={2}>

              {
                  component?.items?.map((item, index) => (
                      <Box
                          key={index}
                          pos="relative"
                          mx={component?.customize_styles?.box_decoration?.margin_x}
                          my={component?.customize_styles?.box_decoration?.margin_y}
                          px={component?.customize_styles?.box_decoration?.padding_x}
                          py={component?.customize_styles?.box_decoration?.padding_y}
                          bg={component?.customize_styles?.box_decoration?.background_color}
                          style={{
                              boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                              borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                              border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                          }}
                      >
                          <Flex justify={'space-between'} align={'flex-start'}>
                              <Box>
                                  <Text
                                      lineClamp={1}
                                      translate="yes"
                                      c={component?.customize_styles?.name_text_decoration?.color}
                                      fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                      fz={component?.customize_styles?.name_text_decoration?.font_size}
                                      fs={component?.customize_styles?.name_text_decoration?.font_style}
                                  >
                                      {item?.name}
                                  </Text>
                              </Box>
                          </Flex>
                          <Image
                              src={item.image_url}
                              fallbackSrc={CategoryPlaceholderImage}
                              // bg={component?.customize_styles?.image_decoration?.color}
                              alt={item.name}
                              radius={component?.customize_styles?.image_decoration?.radius}
                              // h={component?.customize_styles?.image_decoration?.height}
                              // w={component?.customize_styles?.image_decoration?.width}
                              style={{border: "1px solid #ffffff" }}
                          />
                          <Flex mt={15} justify={'space-between'} align={'center'}>
                              <Box>
                                  {
                                      item?.discount_price && (
                                          <Text
                                              c={component?.customize_styles?.product_discount_text_decoration?.color}
                                              fw={component?.customize_styles?.product_discount_text_decoration?.font_weight}
                                              fz={component?.customize_styles?.product_discount_text_decoration?.font_size}
                                              // bg={component?.customize_styles?.product_discount_text_decoration?.background_color}
                                              // td={component?.customize_styles?.product_discount_text_decoration?.text_decoration}
                                              style={{ textDecoration: "line-through" }}
                                          >
                                              {decode(item?.currency)} {item?.price}
                                          </Text>
                                      )
                                  }

                                  <Text
                                      c={component?.customize_styles?.product_price_text_decoration?.color}
                                      fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                      fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                      // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                      td={component?.customize_styles?.product_price_text_decoration?.text_decoration}
                                  >
                                      {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                  </Text>
                              </Box>
                              <Flex bg="#00B9D3" h={35} w={35} justify={"center"} align={"center"} style={{ borderRadius: "10px", float: "right"}}>
                                  <IconPlus color="#ffffff"/>
                              </Flex>
                          </Flex>
                      </Box>

                  ))
              }
          </SimpleGrid>

      </Box>
  );
}

export default _CategoryWithProduct;